/**
 * Gets called by class-toggler when the header's search field is expanded
 */
export const onToggleSearchField = (elm, target) => {
  target.querySelector(".search-form__input").focus();
};
